import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private messageService: MessageService) {}

  success(detail: string, life = 5000) {
    this.messageService.add({ severity: 'success', detail, life });
  }

  info(detail: string, life = 5000) {
    this.messageService.add({ severity: 'info', detail, life });
  }

  warn(detail: string, life = 5000) {
    this.messageService.add({ severity: 'warn', detail, life });
  }

  error(detail: string, life = 8000) {
    this.messageService.add({ severity: 'error', detail, life });
  }
}
